import React, {createContext, useContext, useState, useEffect} from "react";
import ApiServices from "../../../service/ApiServices";

const CartContext = createContext();

const res = new ApiServices();

export const CartProvider = ({children}) => {
    const savedCartId = localStorage.getItem('cartId');

    const [cart, setCart] = useState([]);
    const [cartId, setCartId] = useState(savedCartId);
    const [newItem, setNewItem] = useState(false);

    useEffect(() => {
        res.getCart(cartId).then(setCart);
    }, []);

    useEffect(() => {
        if (newItem) {
            res.getCart(cartId).then(setCart)
            setNewItem(false)
        }
    }, [newItem]);

    const addToCart = (id) => {
        if (!cart.some(item => item.id === id)) {
            res.addToCart({cartId: cartId, productId: id}).then(data => {
                if (data?.cartId) {
                    localStorage.setItem('cartId', data.cartId);
                    setCartId(data?.cartId)
                }
                setNewItem(true);
            });
        }
    }

    const updateCart = (product) => {
        const {id, qty} = product;
    
        setCart(prevCart => {
           if (qty === 0) {
                return prevCart.filter(item => item.id !== id);
           } else {
                return prevCart.map(item => item.id === id ? {...item, qtt: qty} : item);
           }
        });
        
        res.updateCartItem({cartId: cartId, productId: id, qty: qty})
        .then(data => {
            if (data === "clear-cart") {
                localStorage.removeItem('cartId');
                setCartId(null)
            }
        });
    }

    const clearCart = () => {
        localStorage.clear('cartId');
        setCartId(null)
        setCart([])
    }

   

    return (
        <CartContext.Provider
        value={{ cart, cartId,
                addToCart, updateCart, clearCart
        }}>
            {children}
        </CartContext.Provider>
    )
}

export const useCart = () => {
    return useContext(CartContext);
}